if (localStorage.getItem("permission")) {
    if (localStorage.getItem("permission").substring(0,1) != '[') {
        localStorage.setItem('permission', JSON.stringify(localStorage.getItem('permission').split(',')))
    }
}
else {
    localStorage.setItem('permission', JSON.stringify([]))
}

const permission = JSON.parse(localStorage.getItem('permission'));

export const state = {
    code: permission
};

export const getters = {
    isGuranted: (state) => (permissionName) => {
        if (!state.code) {
            return false
        }
        return state.code.includes(permissionName)
    }
}

export const mutations = {
    setPermission(state, code) {
        state.code = code;
    },
    clear(state) {
        state.code = null;
    }
};

export const actions = {
    setPermission({ commit }, code) {
        commit('setPermission', code);
    },
    clear({ commit }) {
        commit('clear');
    }
};
